<template>
  <div>
    <b-modal ref="modelRef" id="log_modal" title="Log">
       <b-container fluid>
         <b-row>
           <b-col><pre v-html="item.log" style="height:300px;overflow-x:auto;white-space:break-spaces;"></pre></b-col>
         </b-row>
       </b-container>
			<div slot="modal-footer">
				<b-button type="button" variant="secondary" data-dismiss="modal" @click="onCancel">Close</b-button>
			</div>
    </b-modal>
  </div>
</template>

<script>
export default {
	props: {
		item: {}
	},
	methods:{
		onCancel(){
			this.$emit('cancel')
			this.$refs.modelRef.hide()
		}
	}
}
</script>